import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { MessageHelper } from '../../providers/helpers/messages';
import { ServiceProvider } from '../../providers/service/service';

@IonicPage()
@Component({
  selector: 'page-alunos-turmas',
  templateUrl: 'alunos-turmas.html',
})
export class AlunosTurmasPage {

  turma: any = null;
  alunos = new Array();

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private msgHelper: MessageHelper, private service: ServiceProvider) {
    this.turma = this.navParams.get("turma");
    this.getAlunos();
  }

  private getAlunos() {

    this.msgHelper.createLoading('crescent', 'Carregando...');
    this.msgHelper.showLoading();

    this.service.postData({
      token: this.turma.token
    }, "/turmas/alunos", false).then(result => {

      this.msgHelper.closeLoading();

      let resultData: any = result;

      if (resultData.result == 0) {
        return this.msgHelper.showAlert("Erro!", resultData.message);
      }

      this.alunos = resultData.data;

    }, error => {
      this.msgHelper.closeLoading();
      this.msgHelper.showAlert("Opps", error.message);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/alunos-turmas/alunos-turmas.ts